import React from "react";
import "./Experience.css";

const experienceData = [
  {
    title: "Full Stack Developer",
    company: "Al Watania Information Systems (Wisys)",
    period: "Sep 2025 - Present",
    description: [
      "Developed and implemented change requests for National Gas & Industrialization Company platforms, including Khazeen and Tazweed, covering front-end, back-end, workflows, and system integrations",
      "Built and maintained integrations using WSDL-based services, and contributed to a shared integration package used as a central communication layer between microservices",
      "Provided technical support and enhancements for the Waqf website using WordPress, along with other web platforms using HTML, CSS, and JavaScript",
      "Engineered enterprise-grade applications using ASP.NET Core and Angular, applying Clean Architecture, CQRS, and SOLID principles for maintainable, testable systems",
    ],
  },
  {
    title: "Frontend Developer",
    company: "Taqneen Software",
    period: "Nov 2024 - Sep 2025",
    description: [
      "Contributing to automation project for Jordan Food and Drug Administration (JFDA), focusing on digitalizing operations and services",
      "Developing solutions to streamline JFDA's administrative processes and regulatory workflows",
      "Contributing to code reviews and supporting interface development to ensure a user-friendly experience",
    ],
  },
  {
    title: "Full-stack Developer Intern",
    company: "Abdul Aziz Al Ghurair School of Advanced Computing (ASAC)",
    period: "Mar 2024 - Nov 2024",
    description: [
      "Developed and maintained multiple full-stack web applications using modern technologies",
      "Implemented user authentication, admin dashboards, and content management systems",
      "Designed and optimized database schemas for efficient data management",
      "Collaborated with team members on code reviews and application architecture",
      "Improved application performance and user experience through optimization techniques",
      "Integrated third-party APIs and services to enhance application functionality",
    ],
  },
  {
    title: "Mobile Apps Developer",
    company: "Self-employed",
    period: "Sep 2023 - Feb 2024",
    description: [
      "Developed cross-platform mobile applications using Flutter and Firebase",
      "Built HHRD Camera app for NGO volunteers to automate data entry and photo organization",
      "Created Ask Me, a Q&A platform with expert responses and content moderation features",
      "Implemented secure user authentication and real-time database management",
    ],
  },
];

const Experience = () => {
  return (
    <section className="experience" id="experience">
      <h2 className="heading">Experience</h2>
      <div className="timeline">
        {experienceData.map((exp, index) => (
          <div
            key={index}
            className={`timeline-item ${index % 2 === 0 ? "left" : "right"}`}
            data-aos={index % 2 === 0 ? "fade-right" : "fade-left"}
            data-aos-delay={300 + index * 100}
          >
            <div className="timeline-content">
              <div className="time-badge">{exp.period}</div>
              <h3 className="role">{exp.title}</h3>
              <h4 className="company">{exp.company}</h4>
              <ul className="description">
                {exp.description.map((item, idx) => (
                  <li key={idx}>{item}</li>
                ))}
              </ul>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default React.memo(Experience);
